module.exports = __webpack_public_path__ + "static/media/Deal-red.712dc1eb.png";